// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_k-1";
export var movingGradient = "_k-4";
export var movingGradientBlock = "_k-2";
export var skeleton = "_k-0";
export var skeletonText = "_k-3";